import './App.css';
import { HashRouter, Route, Routes } from "react-router-dom";
import Dryers from "./Dryers.jsx";
import Housing from './Housing.jsx';
import "bootstrap/dist/css/bootstrap.min.css";
function App() {
  return (
       <div>     
            <HashRouter>
          
              <Routes>
                <Route path="/dryers" element={<Dryers />} />
                 <Route path="/housing" element={<Housing />} />
     
              </Routes>
            </HashRouter>
        
    </div>
  );
}

export default App;
